import React from 'react';
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet';
import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import OutletModal from 'components/Fields/ReduxForm/OutletModal';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import {
  changeOutlet,
  changeDate,
  exportTransaction,
  changeKeyword,
} from 'actions/reports/transactions';
import moment from 'moment';
import * as clevertapReportsTransactions from 'clevertap/reports/transactions';
import MenuTitle from 'components/MenuTitle';
import { isFullSiteMode } from 'utils/fullSite';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';
import { getFormattedTime } from 'utils/hourFilter';
import Dropdown from 'components/Dropdown';
import styleActionBar from './ActionBar.css';

class ActionBar extends React.Component {
  render() {
    const { showModalOutletMobileState } = this.props;

    return (
      <div>
        <MenuTitle menuTitle="Transactions" />
        {!isFullSiteMode() && (
          <div className="col-md-6 element-non-mobi export-transactions">
            <div className="pull-right dropdown-export">
              <Dropdown>
                <Dropdown.Toggle
                  title="Export"
                  bsStyle="primary"
                ></Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem onSelect={this._onClickExportButton}>
                    Transactions
                  </MenuItem>
                  <MenuItem divider />
                  <MenuItem
                    onSelect={this._onClickExportButton}
                    eventKey={'item'}
                  >
                    Item Details
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        )}
        <div className={styleActionBar['mk-action-bar']}>
          <div className="row">
            <div className="col-md-12 col-xs-12 col-sm-12">
              <div
                className={`${
                  styleActionBar['form-group']
                } form-group pull-left visible-md visible-lg`}
              >
                <Field
                  component={DropdownOutlet}
                  name="outlet"
                  onChangeOutletIds={this._onChangeOutlet}
                  outlets={this.props.outlets}
                  allOutletOption
                />
              </div>
              <div
                className={`${
                  styleActionBar['form-group']
                } form-group pull-left`}
              >
                <Field
                  component={DropdownCalendar}
                  name="date"
                  onChange={this._onChangeDate}
                  updateServerOnChange
                />
              </div>
              <div
                className={`${
                  styleActionBar['form-group']
                } form-group pull-left visible-md visible-lg`}
              >
                <Field
                  component={SearchBar}
                  name="keyword"
                  onChange={this._onChangeKeyword}
                  onClick={this._onClickSearchBar}
                  placeholder="Receipt number"
                  className={styleActionBar['search-receipt']}
                />
              </div>
            </div>
          </div>
          <Field
            component={OutletModal}
            name="outlet"
            outlets={this.props.outlets || []}
            onChangeOutletIds={this._onChangeOutlet}
            allOutletOption
            show={showModalOutletMobileState}
          />
        </div>
      </div>
    );
  }

  _onChangeOutlet = outletIds => {
    this.props.dispatch(changeOutlet(outletIds));
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    if (!allDay) {
      startDate = `${moment(startDate).format(`YYYY-MM-DD ${startHour}:00`)}`;
      endDate = `${moment(endDate).format(`YYYY-MM-DD ${endHour}:00`)}`;
    } else {
      startDate = `${moment(startDate).format('YYYY-MM-DD 00:00:00')}`;
      endDate = `${moment(endDate).format('YYYY-MM-DD 23:59:59')}`;
    }
    this.props.dispatch(changeDate(startDate, endDate));
  };

  _onChangeKeyword = (event, keyword) => {
    const {
      date: { startDate, endDate, startHour, endHour, allDay },
    } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeKeyword({
        keyword,
        startDate: formattedStart,
        endDate: formattedEnd,
      })
    );
  };

  _onClickExportButton = reportType => {
    const {
      date: { startDate, endDate, startHour, endHour, allDay },
      outlet,
    } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const query = { start: formattedStart, end: formattedEnd };
    const format = allDay ? 'DD-MM-YYYY' : 'DD-MM-YYYY HH:mm:ss';
    let dateLabel = '';
    if (moment(startDate).isSame(moment(endDate), 'days')) {
      dateLabel = allDay
        ? moment(formattedStart).format(format)
        : [
            moment(formattedStart).format(format),
            moment(formattedEnd).format('HH:mm:ss'),
          ].join(' - ');
    } else {
      dateLabel = [
        moment(formattedStart).format(format),
        moment(formattedEnd).format(format),
      ].join(' - ');
    }

    let filename = '';
    const isItemDetails = reportType === 'item';

    if (isItemDetails) {
      filename = `Report Item Details - ${dateLabel}`;
      clevertapReportsTransactions.reportsTransactionsExportByItem({
        outletIds: outlet,
        startDate: formattedStart,
        endDate: formattedEnd,
      });
    } else {
      filename = `Report Transaction - ${dateLabel}`;
      clevertapReportsTransactions.reportsTransactionsExport({
        outletIds: outlet,
        startDate: formattedStart,
        endDate: formattedEnd,
      });
    }

    this.props.dispatch(
      exportTransaction({ query, filename, outlet, reportType })
    );
  };

  _onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  _onClickSearchBar = () => {
    clevertapReportsTransactions.reportsTransactionsSearchBarInit({});
  };
}

ActionBar.propTypes = {
  outlets: PropTypes.array,
  dispatch: PropTypes.func,
  onChangeKeyword: PropTypes.func,
};

const selector = formValueSelector('search');

function mapStateToProps(state) {
  const { outlets } = state.reports.transactions;
  return {
    outlets,
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
    },
    showModalOutletMobileState: state.moka.showModalOutletMobile,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const mapForm = {
  form: 'search',
};

export default reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ActionBar)
);
